import React from 'react';
import { arrayOf, bool, number, object, string } from 'prop-types';
import { func } from 'prop-types';
import { useDrag, useDrop } from 'react-dnd';
import PlainTableRow from './plainTableRow';

const DraggableRow = ({
  userContext, columns = [], rows = [], uuidName,
  notifyMessages, hasBulkActions, selectedStyles,
  numSelectedRows, classes, row, index, onDragAndDrop }) => {
  const dragAndDropRef = React.useRef(null);
  const [, drop] = useDrop({
    accept: 'row',
    canDrop(item) {
      const dragIndex = item.index;
      const hoverIndex = index;
      return (rows[hoverIndex].droppable && rows[dragIndex].draggable);
    },
    hover(item, monitor) {
      if (!dragAndDropRef.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;
      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return;
      }
      if(!rows[hoverIndex].droppable || !rows[dragIndex].draggable) {
        return;
      }
      // Determine rectangle on screen
      const hoverBoundingRect = dragAndDropRef.current.getBoundingClientRect()
      // Get vertical middle
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      // Determine mouse position
      const clientOffset = monitor.getClientOffset();
      // Get pixels to the top
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%
      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }
      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }
      // Time to actually perform the action
      onDragAndDrop(dragIndex, hoverIndex);
      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      item.index = hoverIndex;
    },
  });

  const [{ isDragging }, drag] = useDrag({
    item: { type: 'row', index },
    collect: monitor => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const opacity = isDragging ? 0 : 1;

  drag(drop(dragAndDropRef));
  return (<PlainTableRow key={row.uuid} {...{
    userContext, columns, rows, uuidName,
    notifyMessages, hasBulkActions, selectedStyles,
    numSelectedRows, classes, row, dragAndDropRef, opacity, allowOrdering: true,
  }} />);
}
export default DraggableRow;

DraggableRow.propTypes = {
  rows: arrayOf(object),
  userContext: object,
  columns: arrayOf(object),
  id: string,
  noResultsMessage: string,
  hasBulkActions: bool,
  selectedRows: arrayOf(string),
  onSelectAllRowsToggle: func,
  row: object,
  uuidName: string,
  notifyMessages: func,
  selectedStyles: arrayOf(string),
  numSelectedRows: number,
  classes: arrayOf(object),
  dragAndDropRef: object,
  opacity: number,
  allowOrdering: bool,
  index: number,
  onDragAndDrop: func,
};